export default {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'stopEditingController',
    template: require('../views/stopEditing.menu.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/stopEditing.menu.component.js